var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosePageButtoninline = function SvgClosePageButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ClosePageButton_inline_svg__close-page-button-inline-svg",
    fill: "#040F1D",
    d: "M16.82 15.91 1.364.456l-.909.91L15.911 16.82.455 32.275l.91.91L16.82 17.728l15.455 15.455.91-.909L17.728 16.82 33.184 1.364l-.909-.909L16.82 15.911z",
    fillRule: "evenodd"
  })));
};
export default SvgClosePageButtoninline;